import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import AEGLogo from '../../../assets/images/logos/AEG/AEG logo.jpg';

const GenericResearchNav = () => {
  const [showNav, setShowNav] = useState(true);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isHighlighted] = useState(true);
  const prevScrollY = useRef(0);
  const location = useLocation();


  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      setShowNav(
        currentScrollY <= 100 || currentScrollY <= prevScrollY.current
      );


      if (isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
      }

      prevScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isMobileMenuOpen]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className={`fixed top-0 w-full z-50 bg-white shadow-md transition-all duration-300 ease-in-out ${showNav ? 'translate-y-0' : '-translate-y-full'}`}>
      <nav className='w-full'>
        <div className='flex items-center justify-between px-5 lg:px-20 xl:px-20 2xl:px-20 py-0 bg-white text-black max-w-full'>
          <Link to='/research-home' className='flex-shrink-0'>
            <img
              src={AEGLogo}
              alt='Assurance Education Group (AEG Research) Logo - Bhopal'
              className='h-16 w-32 sm:h-20 sm:w-40 lg:h-16 lg:w-32 xl:h-20 xl:w-40 2xl:h-24 2xl:w-48 rounded-2xl ml-0 sm:ml-4 lg:ml-4 xl:ml-8 2xl:ml-12'
            />
          </Link>

          {/* Hamburger Menu Button */}
          <button
            className='lg:hidden text-2xl text-black bg-transparent border-none cursor-pointer hover:text-orange-400 transition-colors duration-300'
            onClick={toggleMobileMenu}
          >
            &#9776;
          </button>

          {/* Navigation Links */}
          <ul
            className={`list-none lg:flex lg:items-center lg:gap-1 xl:gap-3 2xl:gap-6 transition-all duration-300 ease-in-out ${
              isMobileMenuOpen
                ? 'flex flex-col absolute top-full left-0 right-0 bg-white shadow-lg border-t p-4 text-black gap-4 text-center w-full'
                : 'hidden lg:flex'
            }`}
          >
            <li>
              <Link to='/research-home'>
                <button className='text-sm 2xl:text-base text-black bg-transparent border-none cursor-pointer px-2 2xl:px-4 py-2 transition-all duration-300 hover:bg-orange-400 rounded font-medium w-full lg:w-auto'>
                  Home
                </button>
              </Link>
            </li>
            <li>
              <Link to='/research-home'>
                <button className='text-sm 2xl:text-base text-black bg-transparent border-none cursor-pointer px-2 2xl:px-4 py-2 transition-all duration-300 hover:bg-orange-400 rounded font-medium w-full lg:w-auto'>
                  About Us
                </button>
              </Link>
            </li>
            <li>
              <Link to='/research-home'>
                <button className='text-sm 2xl:text-base text-black bg-transparent border-none cursor-pointer px-2 2xl:px-4 py-2 transition-all duration-300 hover:bg-orange-400 rounded font-medium w-full lg:w-auto'>
                  Achievements
                </button>
              </Link>
            </li>
            <li>
              <Link to='/research-home'>
                <button className='text-sm 2xl:text-base text-black bg-transparent border-none cursor-pointer px-2 2xl:px-4 py-2 transition-all duration-300 hover:bg-orange-400 rounded font-medium w-full lg:w-auto'>
                  Contact Us
                </button>
              </Link>
            </li>
            <li>
              <Link to='/products'>
                <button className='text-sm 2xl:text-base text-black bg-transparent border-none cursor-pointer px-2 2xl:px-4 py-2 transition-all duration-300 hover:bg-orange-400 rounded font-medium w-full lg:w-auto'>
                  Products
                </button>
              </Link>
            </li>
            <li>
              <Link to='/services'>
                <button className='text-sm 2xl:text-base text-black bg-transparent border-none cursor-pointer px-2 2xl:px-4 py-2 transition-all duration-300 hover:bg-orange-400 rounded font-medium w-full lg:w-auto'>
                  Services
                </button>
              </Link>
            </li>
            {location.pathname !== '/' && (
              <li>
                <Link to='/'>
                  <button
                    className={`bg-blue-600 text-white px-2 2xl:px-4 text-xs xl:text-sm 2xl:text-base py-2 rounded-full font-bold shadow-lg transform transition-all duration-300 ${
                      isHighlighted ? 'animate-pulse' : ''
                    }`}
                  >
                    Back to ResearchLens
                  </button>
                </Link>
              </li>
            )}
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default GenericResearchNav;
